<template>
  <div>
    <div class="billing-cycle-container">
      <h3 for="product"><strong>{{$t('order.billing_cycle.title')}}</strong></h3>
      <div class="parent">
        <div v-if="processing_order">
          <div class="loading-box label"></div>
          <div class="loading-box"></div>
        </div>


        <div v-else v-for="(cycle, index) in cycles" :key="index">
          <div class="card card-product"
               :class="{'active': cycleSelected === cycle.cycle}"
               @click="setCycle(cycle)"
          >
            <div class="pricing">
              <div class="price monthly ">
                <span class="cost">{{ $t('order.billing_cycle.' + cycle.cycle) }}</span>
              </div>
              <div class="price p-name">
                <span class="">{{ formatPrice(cycle.price) }}</span>
              </div>
            </div>
            <div class="details" v-if="cycle.discount !== 0">
              {{$t('order.discount')}} {{(cycle.discount * 100)}}%
            </div>
            <div v-else>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getAxios} from 'services/ajax'
  import {setBillingCycleSettingsFromUrl} from "./AutoloadPlans";

  export default {
    name: "OrderBillingCycle",
    data() {
      return {
        cycles: [],
        load: false,
        cycleSelected: 'Monthly',
        hasPreCycle: false,
        processing_order: false
      }
    },
    props: {
      product: {
        type: Number,
        default: null
      },
      defaultCycle: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      product: function (newQuestion, oldQuestion) {
        console.log('product', newQuestion)

        this.getBillingCycle()
      },
      pre_cycle: function (newQuestion, oldQuestion) {
        console.log('preCycle', newQuestion)

        this.product = newQuestion.id
        this.getBillingCycle()
        this.setCycle(this.cycles['newQuestion'])
      }
    },
    created() {
      this.getBillingCycle()
    },
    methods: {
      setBillingCycleSettingsFromUrl: setBillingCycleSettingsFromUrl,
      setDefaultCycle() {
        this.cycleSelected = 'Monthly'
      },
      formatPrice(prices) {
        let price = 0.0;
        let objPrice = {};

        if (prices.length > 0) {
          objPrice = prices[0]

          if (!(objPrice === null || objPrice === undefined)) {
            price = objPrice.price

            if (objPrice.region_id == 1) {
              price = price.toLocaleString("pt-BR", {style: "currency", currency: "BRL"});
            } else {
              price = price.toLocaleString("en-US", {style: "currency", currency: "USD"});
            }
          }
        }

        return price
      },
      getBillingCycle() {
        this.load = true
        this.processing_order = true

        getAxios().get(`order/billing_cycle/${this.product}`)
          .then(response => {
            this.cycles = response.data.OrderBillingCycle.data;
            this.cycleSelected = 'Monthly'

            this.setBillingCycleSettingsFromUrl()
          })
          .catch(err => {
            this.cycles = []
          })
          .finally(() => {
            this.load = false
            this.processing_order = false
          });
      },
      setCycle(cycle) {
        this.cycleSelected = cycle.cycle
        this.$emit('cycleEvent', cycle)
      }
    },
  }
</script>

<style scoped>
  .carousel slide {
    max-height: 100px;
    width: auto;
    max-width: 100%;
  }

  .card {
    width: 150px;
    height: auto;
    padding: 10px;
    margin: 10px;
  }

  .card-product {
    width: 10vw;
    max-width: 250px;
    text-align: center;
  }

  .card:not(.active):hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }

  .card.active {
    border-color: var(#333);
    box-shadow: black;
    box-shadow: 2px 2px 10px 0px #333;
  }

  .parent {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 15px;
  }

  @media only screen and (max-width: 992px) {
    .card {
      width: 90%;
    }

    .parent {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 1fr;
      grid-column-gap: 15px;
      grid-row-gap: 15px;
    }
  }

  .loading-box {
    height: 42px;
    position: relative;
    background-image: linear-gradient(to right, #EEE 0%, #FAFAFA 20%, #EEE 100%);
    background-color: #EEE;
    animation: 1s shimmer infinite linear;
  }

  .loading-box.label {
    width: 200px;
    height: 16px;
    margin-top: 50px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/OrderBillingCycle.vue